const auth = {
  en: {
    language: 'Language',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    login: {
      tagline1: 'Manage your courses,',
      taglineEm: 'grow your business',
      desc: 'A powerful B2B platform for course creators — upload content, track students, manage orders, and analyse revenue all in one place.',
      feature1Title: 'Course management',
      feature1Desc: 'Upload videos, create lessons, organise modules with ease',
      feature2Title: 'Student tracking',
      feature2Desc: 'Monitor progress, quiz results and engagement in real time',
      feature3Title: 'Revenue analytics',
      feature3Desc: 'See orders, payments and revenue broken down by course',
      feature4Title: 'Live dashboard',
      feature4Desc: 'Everything you need at a glance — always up to date',
      title: 'Welcome back',
      subtitle: 'Sign in to your Darsly CRM account',
      identifierLabel: 'Email or phone',
      identifierPlaceholder: 'you@example.com',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password...',
      forgotPassword: 'Forgot password?',
      signingIn: 'Signing in...',
      signIn: 'Sign in',
      errorDefault: 'Login failed. Check your credentials and try again.',
      errorInvalidCredentials: 'Invalid email or password.',
      errorIdentifier: 'Enter your email or phone number.',
      errorEmail: 'Enter a valid email address.',
      errorPassword: 'Enter your password.',
      noAccount: "Don't have an account?",
      requestAccess: 'Request access',
      teacherPrompt: 'Are you a teacher?',
      teacherLink: 'Teacher portal',
      staffPrompt: 'Are you a staff member?',
      staffLink: 'Staff sign in',
    },
    register: {
      tagline1: 'Start selling courses',
      taglineEm: 'on Darsly today',
      desc: 'Join our growing network of course creators. Get your own B2B workspace to manage content, students and revenue.',
      feature1Title: 'Quick onboarding',
      feature1Desc: 'We review every request and set up your workspace',
      feature2Title: 'Full course toolkit',
      feature2Desc: 'Upload videos, build quizzes, issue certificates',
      feature3Title: 'Secure & private',
      feature3Desc: 'Your data is isolated — only you see your courses and students',
      backToSignIn: 'Back to sign in',
      successTitle: 'Request sent',
      successSubtitle: "We'll review your application and get back to you shortly.",
      successMessage: 'Your access request has been received. The Darsly team will contact you soon at {phone} or {email}.',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign in',
      title: 'Request access',
      subtitle: "Fill in the form and we'll set up your CRM workspace",
      infoBoxBefore: 'Darsly CRM is a',
      infoBoxStrong: 'B2B platform',
      infoBoxAfter: 'for verified course creators. Submit your details and our team will activate your account.',
      nameLabel: 'Full name',
      namePlaceholder: 'Your full name...',
      emailLabel: 'Email address',
      emailPlaceholder: 'you@example.com',
      phoneLabel: 'Phone number',
      phonePlaceholder: '+998 90 123 45 67',
      companyLabel: 'Company / brand name',
      companyPlaceholder: 'Your company or brand...',
      sending: 'Sending request...',
      submit: 'Request access',
      errorPhone: 'Enter a valid phone number, for example +998 90 123 45 67.',
      errorName: 'Enter your full name.',
      errorEmail: 'Enter a valid email address.',
      errorDefault: 'We could not send your request. Please try again or write to {email}.',
    },
    forgotPassword: {
      tagline1: 'Forgot your',
      taglineEm: 'password?',
      desc: "No worries — it happens. Enter the phone number linked to your account and we'll send you a one-time code to set a new password.",
      feature1Title: 'One-time code',
      feature1Desc: 'Sent only to the phone number on your account',
      feature2Title: 'Quick delivery',
      feature2Desc: 'The code arrives in Telegram or by SMS within moments',
      backToSignIn: 'Back to sign in',
      remembered: 'Remembered it?',
      signIn: 'Sign in',
      title: 'Reset password',
      subtitle: "Enter your phone number and we'll send you a verification code",
      phoneLabel: 'Phone number',
      phonePlaceholder: '+998 90 123 45 67',
      noPhoneTitle: 'No phone number on your account?',
      noPhoneBody: 'Ask an administrator to set a new password for you, or write to {email}.',
      sendCode: 'Send code',
      sendingCode: 'Sending code...',
      errorPhone: 'Enter a valid phone number, for example +998 90 123 45 67.',
      errorTooMany: 'Too many codes requested. Please try again in a few minutes.',
      codeTitle: 'Enter the code',
      codeSubtitle: 'We sent a verification code to {phone} in Telegram or by SMS.',
      codeLabel: 'Verification code',
      codePlaceholder: '123456',
      newPasswordLabel: 'New password',
      confirmPasswordLabel: 'Confirm new password',
      passwordPlaceholder: 'Enter a new password...',
      confirmPasswordPlaceholder: 'Repeat the new password...',
      passwordHint: 'At least 8 characters with an uppercase letter, a lowercase letter and a number.',
      resetPassword: 'Reset password',
      resetting: 'Resetting...',
      notReceived: "Didn't get a code? Check Telegram and your messages, or ask an administrator to reset your password.",
      resendCode: 'Send a new code',
      resendIn: 'Send a new code ({seconds}s)',
      changeNumber: 'Use a different number',
      errorCodeRequired: 'Enter the code from the message.',
      errorCode: 'That code is incorrect or has expired. Request a new one.',
      errorPasswordRules: 'Use at least 8 characters with an uppercase letter, a lowercase letter and a number.',
      errorMismatch: 'Passwords do not match.',
      doneTitle: 'Password updated',
      doneSubtitle: 'You can now sign in with your new password.',
      doneTagline1: 'Password updated,',
      doneTaglineEm: 'you can sign in',
      doneDesc: 'Sign in to Darsly CRM with your new password.',
      goToSignIn: 'Go to sign in',
      errorDefault: 'Something went wrong. Please try again.',
    },
  },
  ru: {
    language: 'Язык',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    login: {
      tagline1: 'Управляйте курсами,',
      taglineEm: 'развивайте бизнес',
      desc: 'Мощная B2B-платформа для авторов курсов — загружайте контент, отслеживайте студентов, управляйте заказами и анализируйте доход — всё в одном месте.',
      feature1Title: 'Управление курсами',
      feature1Desc: 'Загружайте видео, создавайте уроки, легко организуйте модули',
      feature2Title: 'Отслеживание студентов',
      feature2Desc: 'Следите за прогрессом, результатами тестов и вовлечённостью в реальном времени',
      feature3Title: 'Аналитика доходов',
      feature3Desc: 'Просматривайте заказы, платежи и доход в разбивке по курсам',
      feature4Title: 'Живая панель',
      feature4Desc: 'Всё необходимое у вас перед глазами — всегда актуально',
      title: 'С возвращением',
      subtitle: 'Войдите в свой аккаунт Darsly CRM',
      identifierLabel: 'Email или телефон',
      identifierPlaceholder: 'you@example.com',
      passwordLabel: 'Пароль',
      passwordPlaceholder: 'Введите пароль...',
      forgotPassword: 'Забыли пароль?',
      signingIn: 'Выполняется вход...',
      signIn: 'Войти',
      errorDefault: 'Не удалось войти. Проверьте данные и попробуйте снова.',
      errorInvalidCredentials: 'Неверный email или пароль.',
      errorIdentifier: 'Введите email или номер телефона.',
      errorEmail: 'Введите корректный email.',
      errorPassword: 'Введите пароль.',
      noAccount: 'Нет аккаунта?',
      requestAccess: 'Запросить доступ',
      teacherPrompt: 'Вы преподаватель?',
      teacherLink: 'Портал преподавателя',
      staffPrompt: 'Вы сотрудник?',
      staffLink: 'Вход для сотрудников',
    },
    register: {
      tagline1: 'Начните продавать курсы',
      taglineEm: 'на Darsly уже сегодня',
      desc: 'Присоединяйтесь к растущему сообществу авторов курсов. Получите собственное B2B-рабочее пространство для управления контентом, студентами и доходом.',
      feature1Title: 'Быстрое подключение',
      feature1Desc: 'Мы проверяем каждую заявку и настраиваем ваше рабочее пространство',
      feature2Title: 'Полный набор инструментов',
      feature2Desc: 'Загружайте видео, создавайте тесты, выдавайте сертификаты',
      feature3Title: 'Безопасно и приватно',
      feature3Desc: 'Ваши данные изолированы — только вы видите свои курсы и студентов',
      backToSignIn: 'Назад ко входу',
      successTitle: 'Заявка отправлена',
      successSubtitle: 'Мы рассмотрим вашу заявку и скоро свяжемся с вами.',
      successMessage: 'Ваш запрос на доступ получен. Команда Darsly скоро свяжется с вами по номеру {phone} или адресу {email}.',
      alreadyHaveAccount: 'Уже есть аккаунт?',
      signIn: 'Войти',
      title: 'Запросить доступ',
      subtitle: 'Заполните форму, и мы настроим ваше рабочее пространство CRM',
      infoBoxBefore: 'Darsly CRM — это',
      infoBoxStrong: 'B2B-платформа',
      infoBoxAfter: 'для проверенных авторов курсов. Отправьте свои данные, и наша команда активирует ваш аккаунт.',
      nameLabel: 'Полное имя',
      namePlaceholder: 'Ваше полное имя...',
      emailLabel: 'Email адрес',
      emailPlaceholder: 'you@example.com',
      phoneLabel: 'Номер телефона',
      phonePlaceholder: '+998 90 123 45 67',
      companyLabel: 'Компания / название бренда',
      companyPlaceholder: 'Ваша компания или бренд...',
      sending: 'Отправка запроса...',
      submit: 'Запросить доступ',
      errorPhone: 'Введите корректный номер телефона, например +998 90 123 45 67.',
      errorName: 'Введите ваше полное имя.',
      errorEmail: 'Введите корректный email.',
      errorDefault: 'Не удалось отправить запрос. Попробуйте снова или напишите на {email}.',
    },
    forgotPassword: {
      tagline1: 'Забыли',
      taglineEm: 'пароль?',
      desc: 'Не переживайте — это бывает. Введите номер телефона, привязанный к аккаунту, и мы отправим одноразовый код для установки нового пароля.',
      feature1Title: 'Одноразовый код',
      feature1Desc: 'Отправляется только на номер телефона вашего аккаунта',
      feature2Title: 'Быстрая доставка',
      feature2Desc: 'Код приходит в Telegram или по SMS в течение нескольких секунд',
      backToSignIn: 'Назад ко входу',
      remembered: 'Вспомнили пароль?',
      signIn: 'Войти',
      title: 'Сброс пароля',
      subtitle: 'Введите номер телефона, и мы отправим вам код подтверждения',
      phoneLabel: 'Номер телефона',
      phonePlaceholder: '+998 90 123 45 67',
      noPhoneTitle: 'В аккаунте нет номера телефона?',
      noPhoneBody: 'Попросите администратора задать вам новый пароль или напишите на {email}.',
      sendCode: 'Отправить код',
      sendingCode: 'Отправка кода...',
      errorPhone: 'Введите корректный номер телефона, например +998 90 123 45 67.',
      errorTooMany: 'Запрошено слишком много кодов. Повторите попытку через несколько минут.',
      codeTitle: 'Введите код',
      codeSubtitle: 'Мы отправили код подтверждения на номер {phone} в Telegram или по SMS.',
      codeLabel: 'Код подтверждения',
      codePlaceholder: '123456',
      newPasswordLabel: 'Новый пароль',
      confirmPasswordLabel: 'Подтвердите новый пароль',
      passwordPlaceholder: 'Введите новый пароль...',
      confirmPasswordPlaceholder: 'Повторите новый пароль...',
      passwordHint: 'Не менее 8 символов, с заглавной и строчной буквой и цифрой.',
      resetPassword: 'Сбросить пароль',
      resetting: 'Сброс...',
      notReceived: 'Не пришёл код? Проверьте Telegram и сообщения или попросите администратора сбросить пароль.',
      resendCode: 'Отправить код ещё раз',
      resendIn: 'Отправить код ещё раз ({seconds} с)',
      changeNumber: 'Использовать другой номер',
      errorCodeRequired: 'Введите код из сообщения.',
      errorCode: 'Код неверный или истёк. Запросите новый.',
      errorPasswordRules: 'Используйте не менее 8 символов, с заглавной и строчной буквой и цифрой.',
      errorMismatch: 'Пароли не совпадают.',
      doneTitle: 'Пароль обновлён',
      doneSubtitle: 'Теперь вы можете войти с новым паролем.',
      doneTagline1: 'Пароль обновлён,',
      doneTaglineEm: 'можно входить',
      doneDesc: 'Войдите в Darsly CRM с новым паролем.',
      goToSignIn: 'Перейти ко входу',
      errorDefault: 'Что-то пошло не так. Попробуйте снова.',
    },
  },
  uz: {
    language: 'Til',
    showPassword: "Parolni ko'rsatish",
    hidePassword: 'Parolni yashirish',
    login: {
      tagline1: 'Kurslaringizni boshqaring,',
      taglineEm: 'biznesingizni rivojlantiring',
      desc: "Kurs yaratuvchilar uchun kuchli B2B platforma — kontent yuklang, o'quvchilarni kuzating, buyurtmalarni boshqaring va daromadni bir joyda tahlil qiling.",
      feature1Title: 'Kurslarni boshqarish',
      feature1Desc: 'Videolar yuklang, darslar yarating, modullarni oson tashkil qiling',
      feature2Title: "O'quvchilarni kuzatish",
      feature2Desc: 'Jarayon, test natijalari va faollikni real vaqtda kuzating',
      feature3Title: 'Daromad tahlili',
      feature3Desc: "Buyurtmalar, to'lovlar va daromadni kurslar bo'yicha ko'ring",
      feature4Title: 'Jonli boshqaruv paneli',
      feature4Desc: "Kerakli barcha ma'lumot bir qarashda — doim yangilangan",
      title: 'Xush kelibsiz',
      subtitle: 'Darsly CRM hisobingizga kiring',
      identifierLabel: 'Email yoki telefon',
      identifierPlaceholder: 'you@example.com',
      passwordLabel: 'Parol',
      passwordPlaceholder: 'Parolingizni kiriting...',
      forgotPassword: 'Parolni unutdingizmi?',
      signingIn: 'Kirilmoqda...',
      signIn: 'Kirish',
      errorDefault: "Kirish amalga oshmadi. Ma'lumotlaringizni tekshirib, qayta urinib ko'ring.",
      errorInvalidCredentials: "Email yoki parol noto'g'ri.",
      errorIdentifier: 'Email yoki telefon raqamini kiriting.',
      errorEmail: "To'g'ri email manzilini kiriting.",
      errorPassword: 'Parolni kiriting.',
      noAccount: "Hisobingiz yo'qmi?",
      requestAccess: "Kirish uchun so'rov yuborish",
      teacherPrompt: "O'qituvchimisiz?",
      teacherLink: "O'qituvchi portali",
      staffPrompt: 'Xodimmisiz?',
      staffLink: 'Xodim sifatida kirish',
    },
    register: {
      tagline1: 'Kurslarni sotishni boshlang',
      taglineEm: "bugun Darsly'da",
      desc: "Kurs yaratuvchilarning o'sib borayotgan jamoasiga qo'shiling. Kontent, o'quvchilar va daromadni boshqarish uchun o'zingizning B2B ish maydoningizni oling.",
      feature1Title: "Tezkor ro'yxatdan o'tish",
      feature1Desc: "Har bir so'rov ko'rib chiqiladi va ish maydoningiz sozlanadi",
      feature2Title: "To'liq kurs vositalari",
      feature2Desc: 'Video yuklang, testlar tuzing, sertifikatlar bering',
      feature3Title: 'Xavfsiz va shaxsiy',
      feature3Desc: "Ma'lumotlaringiz izolyatsiya qilingan — faqat siz o'z kurslaringiz va o'quvchilaringizni ko'rasiz",
      backToSignIn: 'Kirishga qaytish',
      successTitle: "So'rov yuborildi",
      successSubtitle: "Arizangizni ko'rib chiqamiz va tez orada siz bilan bog'lanamiz.",
      successMessage: "So'rovingiz qabul qilindi. Darsly jamoasi tez orada siz bilan {phone} raqami yoki {email} manzili orqali bog'lanadi.",
      alreadyHaveAccount: 'Hisobingiz bormi?',
      signIn: 'Kirish',
      title: "Kirish uchun so'rov",
      subtitle: "Formani to'ldiring, biz CRM ish maydoningizni sozlaymiz",
      infoBoxBefore: 'Darsly CRM — bu',
      infoBoxStrong: 'B2B platforma',
      infoBoxAfter: "tasdiqlangan kurs yaratuvchilar uchun. Ma'lumotlaringizni yuboring, jamoamiz hisobingizni faollashtiradi.",
      nameLabel: "To'liq ism",
      namePlaceholder: "To'liq ismingiz...",
      emailLabel: 'Email manzil',
      emailPlaceholder: 'you@example.com',
      phoneLabel: 'Telefon raqami',
      phonePlaceholder: '+998 90 123 45 67',
      companyLabel: 'Kompaniya / brend nomi',
      companyPlaceholder: 'Kompaniyangiz yoki brendingiz...',
      sending: "So'rov yuborilmoqda...",
      submit: "Kirish uchun so'rov yuborish",
      errorPhone: "To'g'ri telefon raqamini kiriting, masalan +998 90 123 45 67.",
      errorName: "To'liq ismingizni kiriting.",
      errorEmail: "To'g'ri email manzilini kiriting.",
      errorDefault: "So'rovni yuborib bo'lmadi. Qayta urinib ko'ring yoki {email} manziliga yozing.",
    },
    forgotPassword: {
      tagline1: 'Parolingizni',
      taglineEm: 'unutdingizmi?',
      desc: "Xavotir olmang — bu tez-tez bo'lib turadi. Hisobingizga bog'langan telefon raqamini kiriting, biz yangi parol o'rnatish uchun bir martalik kod yuboramiz.",
      feature1Title: 'Bir martalik kod',
      feature1Desc: 'Faqat hisobingizdagi telefon raqamiga yuboriladi',
      feature2Title: 'Tezkor yetkazish',
      feature2Desc: 'Kod Telegram yoki SMS orqali bir necha soniyada keladi',
      backToSignIn: 'Kirishga qaytish',
      remembered: 'Parolingizni eslaysizmi?',
      signIn: 'Kirish',
      title: 'Parolni tiklash',
      subtitle: 'Telefon raqamingizni kiriting, biz sizga tasdiqlash kodini yuboramiz',
      phoneLabel: 'Telefon raqami',
      phonePlaceholder: '+998 90 123 45 67',
      noPhoneTitle: "Hisobingizda telefon raqami yo'qmi?",
      noPhoneBody: "Administratordan yangi parol o'rnatib berishini so'rang yoki {email} manziliga yozing.",
      sendCode: 'Kodni yuborish',
      sendingCode: 'Kod yuborilmoqda...',
      errorPhone: "To'g'ri telefon raqamini kiriting, masalan +998 90 123 45 67.",
      errorTooMany: "Juda ko'p kod so'raldi. Bir necha daqiqadan so'ng qayta urinib ko'ring.",
      codeTitle: 'Kodni kiriting',
      codeSubtitle: 'Tasdiqlash kodini {phone} raqamiga Telegram yoki SMS orqali yubordik.',
      codeLabel: 'Tasdiqlash kodi',
      codePlaceholder: '123456',
      newPasswordLabel: 'Yangi parol',
      confirmPasswordLabel: 'Yangi parolni tasdiqlang',
      passwordPlaceholder: 'Yangi parolni kiriting...',
      confirmPasswordPlaceholder: 'Yangi parolni takrorlang...',
      passwordHint: "Kamida 8 ta belgi: bosh harf, kichik harf va raqam bo'lsin.",
      resetPassword: 'Parolni tiklash',
      resetting: 'Tiklanmoqda...',
      notReceived: "Kod kelmadimi? Telegram va xabarlaringizni tekshiring yoki administratordan parolni tiklashni so'rang.",
      resendCode: 'Yangi kod yuborish',
      resendIn: 'Yangi kod yuborish ({seconds} s)',
      changeNumber: 'Boshqa raqamdan foydalanish',
      errorCodeRequired: 'Xabardagi kodni kiriting.',
      errorCode: "Kod noto'g'ri yoki muddati tugagan. Yangi kod so'rang.",
      errorPasswordRules: "Kamida 8 ta belgi ishlating: bosh harf, kichik harf va raqam bo'lsin.",
      errorMismatch: 'Parollar mos kelmadi.',
      doneTitle: 'Parol yangilandi',
      doneSubtitle: 'Endi yangi parol bilan kirishingiz mumkin.',
      doneTagline1: 'Parol yangilandi,',
      doneTaglineEm: 'kirishingiz mumkin',
      doneDesc: "Darsly CRM'ga yangi parolingiz bilan kiring.",
      goToSignIn: "Kirishga o'tish",
      errorDefault: "Nimadir xato ketdi. Qayta urinib ko'ring.",
    },
  },
};

export default auth;
